import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCustomTasksApi } from "../../http/customTasks/api";
import ModalDialog from "../ui/ModalDialog";

export type CreateSubsidiaryCustomTaskDialogProps = {
  subsidiaryId: string;
  defaultTaskCategory: string;
  onClose: () => void;
};

const CreateSubsidiaryCustomTaskDialog: FC<CreateSubsidiaryCustomTaskDialogProps> = ({
  defaultTaskCategory,
  onClose,
  subsidiaryId,
}) => {
  const i18n = useI18n();

  const customTasksApi = useCustomTasksApi();

  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const craeteTaskCategory = async (subsidiaryID: string, categoryId: string) => {
    try {
      setIsSubmitting(true);
      await customTasksApi.initAdminSubsidiaryCustomTasks(subsidiaryID, categoryId);
      onClose();
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog
      title={i18n.t.customTasks.create}
      onClose={() => onClose()}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          disabled: isSubmitting,
          type: "secondary",
          onClick: () => onClose(),
        },
        {
          title: i18n.t.common.yes,
          disabled: isSubmitting,
          onClick: () => craeteTaskCategory(subsidiaryId, defaultTaskCategory),
        },
      ]}
    >
      {i18n.t.customTasks.questions.customize}
    </ModalDialog>
  );
};

export default CreateSubsidiaryCustomTaskDialog;
